import { render, staticRenderFns } from "./ExamWrongDo.vue?vue&type=template&id=3f9e7dc3&scoped=true"
import script from "./ExamWrongDo.vue?vue&type=script&lang=js"
export * from "./ExamWrongDo.vue?vue&type=script&lang=js"
import style0 from "./ExamWrongDo.vue?vue&type=style&index=0&id=3f9e7dc3&prod&lang=scss&scoped=true"
import style1 from "./ExamWrongDo.vue?vue&type=style&index=1&id=3f9e7dc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9e7dc3",
  null
  
)

export default component.exports